export const CREW_YARD_LISTING = "CREW_YARD_LISTING";
export const CREW_YARD_DETAIL_DATA = "CREW_YARD_DETAIL_DATA";
export const CREW_YARD_FORM_DATA = "CREW_YARD_FORM_DATA";
